(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["is-naehrwerte"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__pjsAllergenHL) return;
  window.__pjsAllergenHL = true;

  function buildPattern(terms) {
    var parts = [];
    terms.forEach(function (raw) {
      var t = (raw || '').trim();
      if (!t) return;
      var p = '';
      for (var i = 0; i < t.length; i++) {
        var c = t[i], lc = c.toLowerCase();
        if (lc === 'ä') p += '[äa]';
        else if (lc === 'ö') p += '[öo]';
        else if (lc === 'ü') p += '[üu]';
        else if (lc === 'ß') p += '(?:ß|ss)';
        else p += c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }
      if (p) parts.push(p);
    });
    if (!parts.length) return null;
    parts.sort(function (a, b) { return b.length - a.length; });
    return new RegExp('(^|[^A-Za-zÄÖÜäöüß])(' + parts.join('|') + ')', 'gi');
  }

  function highlight(el, re) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = walker.nextNode())) {
      if (n.parentNode && n.parentNode.tagName !== 'STRONG') nodes.push(n);
    }
    nodes.forEach(function (node) {
      var txt = node.nodeValue;
      re.lastIndex = 0;
      if (!re.test(txt)) return;
      re.lastIndex = 0;
      var frag = document.createDocumentFragment(), last = 0, m;
      while ((m = re.exec(txt))) {
        var ts = m.index + (m[1] ? m[1].length : 0);
        if (ts > last) frag.appendChild(document.createTextNode(txt.slice(last, ts)));
        var s = document.createElement('strong');
        s.className = 'nw__al';
        s.textContent = m[2].toUpperCase();
        frag.appendChild(s);
        last = ts + m[2].length;
        if (m[0].length === 0) re.lastIndex++;
      }
      if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function run() {
    document.querySelectorAll('[data-nw-zutaten]').forEach(function (el) {
      if (el.dataset.nwDone) return;
      var re = buildPattern((el.getAttribute('data-allergens') || '').split(','));
      if (!re) { el.dataset.nwDone = '1'; return; }
      try { highlight(el, re); } catch (e) {}
      el.dataset.nwDone = '1';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["is-regionwinzer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-tabs')) {
  customElements.define('rw-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      var root = this;
      var labels = (root.getAttribute('data-rw-labels') || '').split('|');
      var n = 2;
      var labelEl = root.querySelector('[data-rw-label]');
      var cur = 0;
      function setActive(i) {
        i = Math.max(0, Math.min(n - 1, i)); cur = i;
        root.querySelectorAll('.rw__tab, .rw__dot').forEach(function (el) {
          var idx = parseInt(el.getAttribute('data-rw-go'), 10);
          if (!isNaN(idx)) { el.classList.toggle('is-active', idx === i); el.setAttribute('aria-selected', idx === i ? 'true' : 'false'); }
        });
        root.querySelectorAll('[data-rw-reiter]').forEach(function (el) {
          el.hidden = parseInt(el.getAttribute('data-rw-reiter'), 10) !== i;
        });
        if (labelEl) labelEl.textContent = labels[i] || '';
        var nx = root.querySelector('[data-rw-next]');
        if (nx) nx.textContent = (labels[(i + 1) % n] || '') + ' ›';
      }
      root.querySelectorAll('[data-rw-go]').forEach(function (el) {
        el.addEventListener('click', function () {
          var v = el.getAttribute('data-rw-go');
          var t = v === 'prev' ? cur - 1 : v === 'next' ? cur + 1 : v === 'toggle' ? (cur + 1) % n : parseInt(v, 10);
          setActive(t);
        });
      });
      var sx = 0, sy = 0, body = root.querySelector('.rw__body');
      if (body) {
        body.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
        body.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { setActive(dx < 0 ? cur + 1 : cur - 1); }
        });
      }
      setActive(0);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-kaufbox"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__pdpKauf) return;
  window.__pdpKauf = true;

  function init(box) {
    if (box.dataset.kaufWired) return;
    box.dataset.kaufWired = '1';
    var data = [];
    try { data = JSON.parse((box.querySelector('[data-pdp-variants]') || {}).textContent || '[]'); } catch (e) {}
    var form = box.querySelector('form[data-type="add-to-cart-form"]') || box.querySelector('form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var cartBtn = form ? form.querySelector('.add-to-cart-button') : null;
    var startSoldOut = box.dataset.state === 'weg';
    var cartText = (cartBtn && !startSoldOut) ? cartBtn.innerHTML : '';
    var section = box.closest('.shopify-section') || document;
    var sixtag = box.querySelector('[data-pdp-sixtag]');
    var texts = { da: box.dataset.textDa || 'Verfügbar', wenig: box.dataset.textWenig || '', weg: box.dataset.textWeg || '' };

    function apply(v) {
      if (!v) return;
      box.dataset.state = v.state;
      var price = box.querySelector('[data-pdp-price]'); if (price) price.textContent = v.price;
      var cmp = box.querySelector('[data-pdp-compare]'); if (cmp) { cmp.textContent = v.compare; cmp.hidden = !v.compare; }
      var promo = box.querySelector('[data-pdp-promo]'); if (promo) { promo.textContent = v.promo; promo.hidden = !v.promo; }
      box.classList.toggle('has-promo', !!v.compare);
      var unit = box.querySelector('[data-pdp-unit]'); if (unit) unit.textContent = v.unit ? v.unit + ' · ' : '';
      var av = box.querySelector('[data-pdp-avtext]'); if (av) av.textContent = texts[v.state] || texts.da;
      var each = box.querySelector('[data-pdp-sixeach]'); if (each) each.textContent = v.six;
      if (sixtag && sixtag.dataset.template) sixtag.textContent = sixtag.dataset.template.replace('[PREIS]', v.six);
      var six = box.querySelector('[data-pdp-six]'); if (six) six.disabled = v.state === 'weg';
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (cartBtn) {
        if (v.state === 'weg') { cartBtn.setAttribute('disabled', ''); cartBtn.textContent = box.dataset.textSoldout || 'Ausverkauft'; }
        else { cartBtn.removeAttribute('disabled'); if (cartText) cartBtn.innerHTML = cartText; else cartBtn.textContent = box.dataset.textAdd || 'In den Warenkorb'; }
      }
      if (qtyInput) qtyInput.disabled = (v.state === 'weg');
      box.querySelectorAll('quantity-selector-component').forEach(function (q) { q.serverDisabledMinus = false; q.serverDisabledPlus = false; if (q.updateButtonStates) { try { q.updateButtonStates(); } catch (e) {} } });
      var jg = section.querySelector('[data-pdp-jahrgang]');
      if (jg && v.label) { var t = (jg.parentNode.textContent || '').replace(jg.textContent, ''); jg.textContent = t.indexOf(v.label) >= 0 ? '' : v.label + ' '; }
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u); } catch (e) {}
    }

    box.querySelectorAll('[data-pdp-vbtn]').forEach(function (b) {
      b.addEventListener('click', function () {
        box.querySelectorAll('[data-pdp-vbtn]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        var v = data.filter(function (x) { return String(x.id) === b.dataset.vid; })[0];
        apply(v);
      });
    });

    // 6er-Paket: Menge setzen, nativen Horizon-Warenkorb-Flow auslösen, Menge zurücksetzen
    var six = box.querySelector('[data-pdp-six]');
    if (six && form && qtyInput) {
      six.addEventListener('click', function () {
        if (six.disabled) return;
        var old = qtyInput.value;
        qtyInput.value = box.dataset.sixQty || '6';
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        setTimeout(function () { qtyInput.value = old; }, 1200);
      });
    }

    // Lager-Meldungen freundlicher formulieren.
    // Die Texte kommen teils vom Shopify-Server (Warenkorb-Antwort), stehen also NICHT im Theme.
    // Deshalb wird der eingeblendete Text nachträglich ersetzt — nur bei erkannten Fällen,
    // alles andere bleibt unverändert stehen, damit keine Meldung verfälscht wird.
    if (box.dataset.msgOn === '1') {
      // Höchstmenge: den Vorlagentext des Horizon-Formulars direkt austauschen
      var pfc = box.querySelector('product-form-component');
      // Horizon ersetzt im Meldungstext selbst einen Platzhalter in doppelten
      // geschweiften Klammern. Er wird hier aus Teilen zusammengesetzt, damit der
      // Theme-Check ihn nicht faelschlich fuer eine Liquid-Variable haelt.
      var MAXTOKEN = '{' + '{ maximum }' + '}';
      if (pfc && box.dataset.msgMax) pfc.dataset.quantityErrorMax = box.dataset.msgMax.replace(/\[ANZAHL\]/g, MAXTOKEN);

      var errEl = box.querySelector('.product-form-text__error');
      var msgAll = box.dataset.msgAll || '';
      var msgPart = box.dataset.msgPart || '';
      if (errEl && (msgAll || msgPart)) {
        var lastWritten = '';
        var rewrite = function () {
          if (errEl.classList.contains('hidden')) return;
          var node = null;
          for (var i = errEl.childNodes.length - 1; i >= 0; i--) {
            var n = errEl.childNodes[i];
            if (n.nodeType === 3 && n.textContent.trim()) { node = n; break; }
          }
          if (!node) return;
          var txt = node.textContent.trim();
          if (!txt || txt === lastWritten) return;
          var num = (txt.match(/\d+/) || [])[0] || '';
          var out = '';
          if (/bereits|already/i.test(txt) && msgAll) out = msgAll;
          else if (num && /(verf(ü|ue)gbarkeit|availability|nur |only )/i.test(txt) && msgPart) out = msgPart;
          if (!out) return;
          out = out.replace(/\[ANZAHL\]/g, num).trim();
          lastWritten = out;
          node.textContent = ' ' + out;
        };
        new MutationObserver(rewrite).observe(errEl, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
        rewrite();
      }
    }

    // Mengenschritt (z. B. Bier: 4er-Schritte)
    var step = parseInt(box.dataset.qtyStep || '1', 10);
    if (step > 1 && qtyInput) {
      qtyInput.min = step; qtyInput.step = step;
      if (parseInt(qtyInput.value || '0', 10) < step) qtyInput.value = step;
      var fix = function (n) { n = Math.max(step, Math.round(n / step) * step); qtyInput.value = n; qtyInput.dispatchEvent(new Event('change', { bubbles: true })); };
      // Horizons Plus/Minus rechnen selbst mit input.step; hier nur freie Eingaben aufs Raster ziehen
      qtyInput.addEventListener('change', function () { var n = parseInt(qtyInput.value || '0', 10); var m = Math.max(step, Math.round(n / step) * step); if (m !== n) fix(m); });
    }
  }

  function run(scope) {
    (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-pdp-buy]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  document.addEventListener('pdp:rewire', function (e) { run(e.detail && e.detail.scope); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-tasting-buchung"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__tgBuchung) return;
  window.__tgBuchung = true;

  var mq = window.matchMedia('(max-width: 749px)');
  function money(cents) {
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  function init(box) {
    if (box.dataset.wired) return;
    box.dataset.wired = '1';
    var data = [];
    try { data = JSON.parse((box.querySelector('[data-tg-variants]') || {}).textContent || '[]'); } catch (e) {}
    var form = box.querySelector('form[data-type="add-to-cart-form"]') || box.querySelector('form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var btn = form ? form.querySelector('.add-to-cart-button, button[name="add"]') : null;
    var cur = data.filter(function (x) { return idInput && String(x.id) === String(idInput.value); })[0]
      || data.filter(function (x) { return x.state !== 'voll'; })[0] || data[0];

    // Nur den Textknoten des Horizon-Buttons tauschen, Symbol und Animation bleiben erhalten
    function setText(t) {
      if (!btn || !t) return;
      var node = null;
      for (var i = 0; i < btn.childNodes.length; i++) {
        var n = btn.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) { node = n; break; }
      }
      if (node) { if (node.textContent.trim() !== t) node.textContent = ' ' + t + ' '; }
      else btn.insertBefore(document.createTextNode(t), btn.querySelector('.add-to-cart__added'));
    }

    function label() {
      if (!cur) return;
      if (cur.state === 'voll') { setText(box.dataset.textFull || 'Ausgebucht'); if (btn) btn.disabled = true; return; }
      var q = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
      var t = (mq.matches && box.dataset.ctaMobile) ? box.dataset.ctaMobile.replace('[SUMME]', money(cur.cents * q)) : (box.dataset.cta || 'Plätze reservieren');
      setText(t);
    }

    function apply(v) {
      if (!v) return;
      cur = v;
      var p = box.querySelector('[data-tg-price]'); if (p) p.textContent = v.price;
      if (idInput && String(idInput.value) !== String(v.id)) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      var low = box.querySelector('[data-tg-low]');
      var lt = box.querySelector('[data-tg-lowtext]');
      if (low) {
        var show = v.state === 'wenig';
        low.hidden = !show;
        if (show && lt && box.dataset.lowText) lt.textContent = box.dataset.lowText.replace('[ANZAHL]', v.seats > 0 ? v.seats : '').replace(/\s+/g, ' ').trim();
      }
      if (btn) btn.disabled = v.state === 'voll';
      if (qtyInput) {
        if (v.seats > 0) {
          qtyInput.max = v.seats;
          if ((parseInt(qtyInput.value || '1', 10) || 1) > v.seats) { qtyInput.value = v.seats; qtyInput.dispatchEvent(new Event('change', { bubbles: true })); }
        } else { qtyInput.removeAttribute('max'); }
      }
      box.querySelectorAll('quantity-selector-component').forEach(function (q) { q.serverDisabledMinus = false; q.serverDisabledPlus = false; if (q.updateButtonStates) { try { q.updateButtonStates(); } catch (e) {} } });
      label();
    }

    box.querySelectorAll('[data-tg-vid]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        box.querySelectorAll('[data-tg-vid]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
        apply(data.filter(function (x) { return String(x.id) === b.dataset.tgVid; })[0]);
        try { var u = new URL(window.location.href); u.searchParams.set('variant', b.dataset.tgVid); window.history.replaceState({}, '', u); } catch (e) {}
      });
    });

    if (qtyInput) { qtyInput.addEventListener('change', label); qtyInput.addEventListener('input', label); }
    box.addEventListener('click', function (e) { if (e.target.closest('quantity-selector-component button, .quantity-selector button')) setTimeout(label, 30); });
    if (mq.addEventListener) mq.addEventListener('change', label); else if (mq.addListener) mq.addListener(label);
    // Horizon schreibt den Buttontext nach dem Hinzufügen teils neu: dann wieder unseren Text setzen
    if (btn) new MutationObserver(function () { label(); }).observe(btn, { childList: true, characterData: true, subtree: true });
    apply(cur);
  }

  function run(scope) {
    (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-tg-buchung]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  document.addEventListener('pdp:rewire', function (e) { run(e.detail && e.detail.scope); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-unterbild"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__pdpUb) return; window.__pdpUb = true;
  function wire(root) {
    if (root.dataset.wired) return; root.dataset.wired = '1';
    root.querySelectorAll('[data-ub-tab]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.ubTab;
        root.querySelectorAll('[data-ub-tab]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        root.querySelectorAll('[data-ub-panel]').forEach(function (p) { p.hidden = p.dataset.ubPanel !== k; });
        var logo = root.querySelector('[data-ub-logo]'); if (logo) logo.hidden = k !== 'maker';
        root.dataset.ubActive = k;
      });
    });
    var more = root.querySelector('[data-ub-more]');
    if (more) more.addEventListener('click', function () {
      var on = root.querySelector('[data-ub-tab].is-on');
      var k = root.dataset.ubActive || (on ? on.dataset.ubTab : 'maker');
      try { window.sessionStorage.setItem('pdp-kombi-tab', k || 'maker'); } catch (e) {}
      document.dispatchEvent(new CustomEvent('pdp:kombi', { detail: { tab: k } }));
    });
  }
  function run(scope) { (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-pdp-ub]').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); }); else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  document.addEventListener('pdp:rewire', function (e) { run(e.detail && e.detail.scope); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdpd-kombi"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__pdpKombi) return; window.__pdpKombi = true;
  function setTab(root, k) {
    var btn = root.querySelector('[data-ko-tab="' + k + '"]'); if (!btn) return;
    root.querySelectorAll('[data-ko-tab]').forEach(function (x) { x.classList.toggle('is-on', x === btn); });
    root.querySelectorAll('[data-ko-panel]').forEach(function (p) { p.hidden = p.dataset.koPanel !== k; });
    root.querySelectorAll('.pdp-clamp').forEach(function (c) { c.classList.remove('is-open'); if (c.__pdpMeasure) c.__pdpMeasure(); });
    if (window.__pdpAutoClamp) window.__pdpAutoClamp(root.closest('.section-pdp-details') || document);
  }
  function wire(root) {
    if (root.dataset.wired) return; root.dataset.wired = '1';
    root.querySelectorAll('[data-ko-tab]').forEach(function (b) { b.addEventListener('click', function () { setTab(root, b.dataset.koTab); }); });
    var pre = null;
    try { pre = window.sessionStorage.getItem('pdp-kombi-tab'); window.sessionStorage.removeItem('pdp-kombi-tab'); } catch (e) {}
    if (pre) setTab(root, pre);
  }
  document.addEventListener('pdp:kombi', function (e) {
    var k = e.detail && e.detail.tab; if (!k) return;
    document.querySelectorAll('[data-pdp-kombi]').forEach(function (r) { setTab(r, k); });
  });
  function run(scope) { (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-pdp-kombi]').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); }); else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
  } catch(e) { console.error(e); }
})();

})();
